import { render, staticRenderFns } from "./MasterClasses.vue?vue&type=template&id=0547c2ee&"
import script from "./MasterClasses.vue?vue&type=script&lang=js&"
export * from "./MasterClasses.vue?vue&type=script&lang=js&"
import style0 from "./MasterClasses.vue?vue&type=style&index=0&id=0547c2ee&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports